import Vue from 'vue';
import Message from 'element-ui/lib/message';
// eslint-disable-next-line
import css from './message.scss';

Vue.prototype.$message = Message;

/* eslint-disable */
// Seems weird. exporting as default causes an error in bundled js file.
export { Message };

